/**
 * Efficiency Ratio (Kaufman)
 *
 * Measures the efficiency of price movement.
 * ER = |Price Change over N| / Sum of |Price Changes|
 * 1.0 = perfectly trending, 0.0 = completely choppy.
 *
 * Category: Trend | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const efficiencyRatioIndicator: IndicatorDefinition = {
  id: "efficiency_ratio",
  name: "Efficiency Ratio",
  shortName: "ER",
  category: "trend",
  pane: "separate",
  params: [
    { key: "period", label: "Period", type: "number", default: 10, min: 2, max: 200 },
  ],
  plots: [
    { key: "er", label: "ER", color: "#7E57C2", style: "line", lineWidth: 2 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period } = params;
    const erData: { time: number; value: number }[] = [];

    for (let i = period; i < candles.length; i++) {
      const direction = Math.abs(candles[i].close - candles[i - period].close);
      let volatility = 0;
      for (let j = i - period + 1; j <= i; j++) {
        volatility += Math.abs(candles[j].close - candles[j - 1].close);
      }
      const er = volatility > 0 ? direction / volatility : 0;
      erData.push({ time: candles[i].time, value: er });
    }

    return [{ key: "er", data: erData }];
  },
};
